<div *ngIf="label != 'undefined'" class="upload-label">{{ label }}</div>
<div class="attachment-holder drop-area" [style.min-height]="height" [ngClass]="{'drag' : isDrag}"
  (dragover)="dragStarted($event)" (dragleave)="dragStop($event)" (drop)="onFileDrop($event)">
<div class="upload-bar">
    <label for="addressFile">
      <i class="material-icons">cloud_upload</i> Drag and drop or
      <span class="file-input-label">Browse</span>
    </label>
    <input multiple class="file-input" type="file" (change)="uploadFile($event.target.files[0])"
      [disabled]="disableControl" />
</div>
  <div *ngIf="attachments?.length > 0 && type == 'file'" class="file-list">
    <div>{{attachments?.length}}
      <span *ngIf="attachments?.length == 1">file</span>
      <span *ngIf="attachments?.length > 1">files</span>
    </div>
    <ul>
      <li *ngFor="let file of attachments; let i = index">
        <a href="" class="link" *ngIf="!disableControl">
          <i class="material-icons delete" (click)="removeFile($event, i)">delete</i>
        </a>
        <a *ngIf="file.DocumentID" matTooltip="{{ file.FileName }}" class="link" target="_blank"
          (click)="download(file)">{{ file.FileName }}</a>
        <a *ngIf="!file.DocumentID" matTooltip="{{ file.FileName }}" download="{{ file.FileName }}"
          target="_blank">{{ file.FileName }}</a>
      </li>
    </ul>
  </div>
</div>